import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { BiTematica } from '../../models/bi-tematica.model';
import { BiTematicaService } from '../../services/bi-tematica.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-bi-tematica-list',
  templateUrl: './bi-tematica-list.component.html',
  styleUrls: ['./bi-tematica-list.component.scss']
})
export class BiTematicaListComponent extends BaseListComponent<BiTematica> implements OnInit, OnDestroy {

  biTematicaList: BiTematica[];

  constructor(
    private myService: BiTematicaService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.biTematicaList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/bi-tematica/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/bi-tematica/', id];
  }
}

